import { useContext } from 'react';
import { SessionContext } from '../../../js/app/contexts/SessionContext';

export function useStaffOrHasPermission(permission: string) {
  const { user, audienceIsStaff } = useContext(SessionContext);

  return Boolean(audienceIsStaff) || Boolean(user?.permissions?.includes(permission));
}
